<template>
  <field-label :label="label" :required="required">
    <v-textarea
      outlined
      dense
      :placeholder="computedPlaceholder"
      :counter="computedMaxLength"
      :rules="computedRules"
      :value="value"
      :auto-grow="autoGrow"
      :no-resize="noResize"
      :rows="rows"
      v-on="$listeners"
      v-bind="$attrs"
      :maxlength="maxLength"
      :disabled="disabled"
      v-if="!readonly"
    />

    <div v-else class="textarea--readonly">{{ value }}</div>
  </field-label>
</template>

<script>
import FieldLabel from './FieldLabel.vue'
export default {
  name: 'TextArea',
  components: { FieldLabel },
  computed: {
    computedMaxLength() {
      return this.maxLength > 0 && !this.readonly ? this.maxLength : undefined
    },
    computedPlaceholder() {
      return this.readonly ? null : this.placeholder ?? this.label
    },
    computedRules() {
      const rules = []
      if (this.required) {
        rules.push(this.$validation.required())
      }
      if (this.computedMaxLength) {
        rules.push(this.$validation.maxChars(this.computedMaxLength))
      }
      rules.push(...(this.rules ?? []))
      return rules
    },
  },
  props: {
    value: String,
    label: String,
    maxLength: {
      type: Number,
    },
    rules: Array,
    required: Boolean,
    placeholder: String,
    noResize: Boolean,
    autoGrow: Boolean,
    rows: [Number, String],
    disabled: Boolean,
    readonly: Boolean,
  },
}
</script>

<style scoped>
.textarea--readonly {
  max-height: 300px;
  overflow-y: auto;
  line-height: 1.7rem;
  font-size: 1.05rem;
  padding-right: 8px;
  padding-left: 4px;
  white-space: pre-line;
}
</style>
